import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import { AutoCloseAlertTitle, Timer } from "../../../../Constants/Constants";
import { AutoCloseAlertSubTitle } from "../../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AutoCloseAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Auto close alert!",
      text: "just a wait! I will close in 30 second!",
      timer: 3000,
      showConfirmButton: false,
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={AutoCloseAlertTitle} span={AutoCloseAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="sweet-14" onClick={handleAlert}>
            {Timer}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default AutoCloseAlert;
